import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import type { RuleInput, RuleCondition, RuleAction } from '@webmail/shared';
import { rulesApi } from '../lib/api';

// Regola come restituita dall'API (RuleInput + campi generati dal server)
export interface Rule extends RuleInput {
  id: string;
  created_at?: string;
  updated_at?: string;
}

export type { RuleInput, RuleCondition, RuleAction };

export function useRules() {
  return useQuery({
    queryKey: ['rules'],
    queryFn: async () => {
      const res = await rulesApi.list();
      return (res?.rules ?? res ?? []) as Rule[];
    },
  });
}

export function useCreateRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RuleInput) => rulesApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rules'] }),
  });
}

export function useUpdateRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<RuleInput> }) =>
      rulesApi.update(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rules'] }),
  });
}

export function useDeleteRule() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => rulesApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['rules'] }),
  });
}
